import { render, staticRenderFns } from "./mySoundWall.vue?vue&type=template&id=266f06d7&scoped=true&"
import script from "./mySoundWall.vue?vue&type=script&lang=js&"
export * from "./mySoundWall.vue?vue&type=script&lang=js&"
import style0 from "./mySoundWall.vue?vue&type=style&index=0&id=266f06d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f06d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266f06d7')) {
      api.createRecord('266f06d7', component.options)
    } else {
      api.reload('266f06d7', component.options)
    }
    module.hot.accept("./mySoundWall.vue?vue&type=template&id=266f06d7&scoped=true&", function () {
      api.rerender('266f06d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/mySoundWall.vue"
export default component.exports